import React, {Component} from 'react';
import {deepCopyObject, showAxiosError} from "../../util/Helpers";
import {Form, Input} from "antd";
import {Label, UncontrolledTooltip} from "reactstrap";
import './MemberList.css';
import LoadingIndicator from "../../common/LoadingIndicator";
import {validateComponent, validateField} from "../../common/validation";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";

const {TextArea} = Input;

class MemberContactInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            isLoading: false,
            authRoles: [],
            fieldsDisabled: false,
            mode: this.props.mode,
            addresses: null,
            memberInfo: {
                id: null,
                ad: "",
                soyad: "",
                tcKimlikNo: "",
                dogumTarihi: "",
                kimlikTipi: "",
                cuzdanKimlikSeriNo: "",
                kayitNo: "",
                kimlikSonGecerlilikTarihi: "",
                babaAdi: "",
                anaAdi: "",
                dogumYeri: "",
                medeniHali: "",
                kanGrubu: "",
                eposta: "",
                evTel: "",
                gsmTel: "",
                isTel: "",
                isAdres: "",
                ikametAdres: "",
                odaKayitTarihi: "",//
                odaSicilNo: "",//
                universite: "",
                mezuniyetTarihi: "",
                diplomaNo: "",
                ruhsatTarihi: "",
                ruhsatNo: "",
                vergiDairesiAd: "",
                vergiNo: "",
                fotoFile: "",
                kimlikCuzdanFile: "",
                adliSicilFile: "",
                ruhsatnameFile: "",
                diplomaFile: "",
                ikametgahFile: "",
                basvuruDurumu: "",
                basvuruReddedilmeSebebi: "",
                ruhsatAktif: false,
                uyelikAktif: false,
                uyelikPasiflikNedeni: "",
                user_id: "",
                city: {
                    id: null,
                    plakaKod: null,
                    ad: null,
                    oda: {
                        id: null,
                        ad: null,
                        adres: null,
                        telefonNo: null,
                        email: null,
                        webSitesiURL: null,
                        kurulusKararNo: null
                    }
                }
            },
            cities: null,
            citySubdivisions: null,
        };


        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateField = this.validateField.bind(this);
        this.getAddresses = this.getAddresses.bind(this);
        this.listCities = this.listCities.bind(this);
        this.listCitySubdivisions = this.listCitySubdivisions.bind(this);

    }

    getAddresses() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/address/" + this.props.selectedMember.id,
            method: "get",
        };
        request(params)
            .then(function (response) {
                let addresses = response.data;
                self.setState({
                    addresses,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }


    componentDidMount() {
        this.getAddresses();
        this.listCities();
        this.listCitySubdivisions();


        if (this.state.mode === 'review') {
            this.setState({fieldsDisabled: true});
        }
        if (this.props.selectedMember) {
            let selectedMember = deepCopyObject(this.props.selectedMember);
            // selectedMember.dogumTarihi= (selectedMember.dogumTarihi!==null) ? moment.utc(selectedMember.dogumTarihi.substring(0,selectedMember.dogumTarihi.indexOf('T')),"YYYY-MM-DD"): null;
            // selectedMember.kimlikSonGecerlilikTarihi= (selectedMember.kimlikSonGecerlilikTarihi!==null) ? moment.utc(selectedMember.kimlikSonGecerlilikTarihi.substring(0,selectedMember.kimlikSonGecerlilikTarihi.indexOf('T')),"YYYY-MM-DD"):null;
            // selectedMember.mezuniyetTarihi= (selectedMember.mezuniyetTarihi!==null) ? moment.utc(selectedMember.mezuniyetTarihi.substring(0,selectedMember.mezuniyetTarihi.indexOf('T')),"YYYY-MM-DD"):null;
            // selectedMember.ruhsatTarihi=(selectedMember.ruhsatTarihi!==null) ? moment.utc(selectedMember.ruhsatTarihi.substring(0,selectedMember.ruhsatTarihi.indexOf('T')),"YYYY-MM-DD"): null;
            this.setState({memberInfo: selectedMember});
        }
    }

    listCities() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/city/",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let cities = response.data;
                self.setState({
                    cities,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listCitySubdivisions() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/city-subdivision/orderedById",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let citySubdivisions = response.data;
                self.setState({
                    citySubdivisions,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }


    render() {

        let workAddress = this.state.addresses && this.state.addresses[1].addressString.toString();
        let workSemt = this.state.addresses && this.state.addresses[1].workSemt.toString();
        let workCity = this.state.addresses && this.state.cities && this.state.cities[this.state.addresses[1].cityId - 1].ad.toString();
        let workCitySub = this.state.addresses && this.state.citySubdivisions && this.state.citySubdivisions[this.state.addresses[1].citysubdivisionId - 1].name.toString();
        let fullWorkAddress = workAddress && workSemt && workCity && workCitySub && workAddress.concat(' ', workSemt, ' ', workCitySub, ' ', workCity);

        let permAddress = this.state.addresses && this.state.addresses[0].addressString.toString();
        let permSemt = this.state.addresses && this.state.addresses[0].permSemt.toString();
        let permCity = this.state.addresses && this.state.cities && this.state.cities[this.state.addresses[0].cityId - 1].ad.toString();
        let permCitySub = this.state.addresses && this.state.citySubdivisions && this.state.citySubdivisions[this.state.addresses[0].citysubdivisionId - 1].name.toString();
        let fullPermAddress = permAddress && permSemt && permCity && permCitySub && permAddress.concat(' ', permSemt, ' ', permCitySub, ' ', permCity);


        return (
            <div>
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="memberForm-container">
                    <div className="page-title">
                        <br/>İLETİŞİM BİLGİLERİNİZ<br/>
                    </div>
                    <Form>
                        <div className="row">
                            <Label className="col-sm-3">GSM Telefonu:</Label>
                            <div className={"col-sm-7 form-group" + this.validateClass('tGsmTel')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.fieldsDisabled}
                                       name="gsmTel"
                                       id="tGsmTel"
                                       maxLength="11"
                                       data-vlength="11"
                                       inputProps={{'vdata': "required", 'vlength': "11"}}
                                       ref="tGsmTel"
                                       value={this.state.memberInfo.gsmTel}
                                       onChange={(e) => this.onChangeMember("gsmTel", e.target.value)}/>
                                {this.validateMessage('tGsmTel') !== "" &&
                                <UncontrolledTooltip placement="right" target="tGsmTel" delay={0}>
                                    {this.validateMessage("tGsmTel")}
                                </UncontrolledTooltip>}
                            </div>

                        </div>
                        <div className="row">
                            <Label className="col-sm-3">İş Yeri Telefonu:</Label>
                            <div className={"col-sm-7 form-group" + this.validateClass('tIsTel')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.fieldsDisabled}
                                       name="isTel"
                                       id="tIsTel"
                                       maxLength="11"
                                       data-vlength="11"
                                       inputProps={{'vdata': "required", 'vlength': "11"}}
                                       ref="tIsTel"
                                       value={this.state.memberInfo.isTel}
                                       onChange={(e) => this.onChangeMember("isTel", e.target.value)}/>
                                {this.validateMessage('tIsTel') !== "" &&
                                <UncontrolledTooltip placement="right" target="tIsTel" delay={0}>
                                    {this.validateMessage("tIsTel")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>

                        <div className="row">
                            <Label className="col-sm-3">Ev Telefonu:</Label>
                            <div className={"col-sm-7 form-group" + this.validateClass('tEvTel')}>
                                <Input className="form-control"
                                       type="text"
                                       disabled={this.state.fieldsDisabled}
                                       name="evTel"
                                       id="tEvTel"
                                       maxLength="11"
                                       data-vlength="11"
                                       inputProps={{'vdata': "required", 'vlength': "11"}}
                                       ref="tEvTel"
                                       value={this.state.memberInfo.evTel}
                                       onChange={(e) => this.onChangeMember("evTel", e.target.value)}/>
                                {this.validateMessage('tEvTel') !== "" &&
                                <UncontrolledTooltip placement="right" target="tEvTel" delay={0}>
                                    {this.validateMessage("tEvTel")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>

                        <div className="row">
                            <Label className="col-sm-3">İkamet Adresi:</Label>
                            <div className={"col-sm-7 form-group" + this.validateClass('tIkametAdres')}>
                                <TextArea className="form-control"
                                          type="text"
                                          disabled={this.state.fieldsDisabled}
                                          name="ikametAdres"
                                          id="tIkametAdres"
                                          maxLength="255"
                                          data-vlength="255"
                                          style={{height: "70px",}}
                                          inputProps={{'vdata': "required", 'vlength': "255"}}
                                          ref="tIkametAdres"
                                          value={fullPermAddress && fullPermAddress}
                                          onChange={(e) => this.onChangeMember("ikametAdres", e.target.value)}/>
                                {this.validateMessage('tIkametAdres') !== "" &&
                                <UncontrolledTooltip placement="right" target="tIkametAdres" delay={0}>
                                    {this.validateMessage("tIkametAdres")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>

                        <div className="row">
                            <Label className="col-sm-3">İş Yeri Adresi:</Label>
                            <div className={"col-sm-7 form-group" + this.validateClass('tIsAdres')}>
                                <TextArea className="form-control"
                                          type="text"
                                          disabled={this.state.fieldsDisabled}
                                          name="isAdres"
                                          id="tIsAdres"
                                          maxLength="255"
                                          style={{height: "70px",}}
                                          data-vlength="255"
                                          inputProps={{'vdata': "required", 'vlength': "255"}}
                                          ref="tIsAdres"
                                          value={fullWorkAddress && fullWorkAddress}
                                          onChange={(e) => this.onChangeMember("isAdres", e.target.value)}/>
                                {this.validateMessage('tIsAdres') !== "" &&
                                <UncontrolledTooltip placement="right" target="tIsAdres" delay={0}>
                                    {this.validateMessage("tIsAdres")}
                                </UncontrolledTooltip>}
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
}

export default MemberContactInfo;


// WEBPACK FOOTER //
// ./src/page/memberList/MemberContactInfo.js